<template>
  <div class="message">
    <!-- <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      class="page_scroll"> -->
    <div class="message-out">
      <div class="message-goout">
        <!-- ../assets/images/j-i3 -->
        <a class="loginOut" @click="loginOut"></a>
      </div>
      <div class="message-avator">
        <img :src="photo" alt="">
        <!-- <img src="../assets/images/j-i2.png" alt=""> -->
        <p>{{name}}</p>
      </div>
      <!--      医生-->
      <div class="message-list" v-show="type == 1">
        <ul>
          <li>
            <router-link to="/recommend">
              <img src="../assets/images/j-i5.png" alt="">
              <p>推荐用户</p>
            </router-link>
          </li>
          <li>
            <router-link to="/shopys/3">
              <img src="../assets/images/j-i9.png" alt="">
              <p>代下单</p>
            </router-link>
          </li>
          <li>
            <router-link to="/Statistics_doc">
              <img src="../assets/images/j-i6.png" alt="">
              <p>查看订单</p>
            </router-link>
          </li>
          <li>
            <router-link to="/account">
              <img src="../assets/images/j-i9.png" alt="">
              <p>账号管理</p>
            </router-link>
          </li>
          <li>
            <router-link to="/qrcode">
              <img src="../assets/images/j-i8.png" alt="">
              <p>专属二维码</p>
            </router-link>
          </li>
        </ul>
      </div>

      <!--      业务员-->
      <div class="message-list2" v-show="type == 2">
        <ul>
          <li>
            <router-link to="/recommend">
              <img src="../assets/images/j-i4.png" alt="">
              <p>推荐用户</p>
            </router-link>
          </li>
          <li>
            <router-link to="/recommendDoctor">
              <img src="../assets/images/j-i5.png" alt="">
              <p>推荐医生</p>
            </router-link>
          </li>
          <li>
            <router-link to="/addDoctor">
              <img src="../assets/images/j-i7.png" alt="">
              <p>添加医生账号</p>
            </router-link>
          </li>
          <li>
            <router-link to="/Statistics_sale">
              <img src="../assets/images/j-i6.png" alt="">
              <p>查看订单</p>
            </router-link>
          </li>

          <li>
            <router-link to="/shopywy/2">
              <img src="../assets/images/j-i9.png" alt="">
              <p>代下单</p>
            </router-link>
          </li>
          <!-- <li>
            <router-link to="/addDoctor">
              <img src="../assets/images/j-i7.png" alt="">
              <p>添加医生账号</p>
            </router-link>
          </li> -->
          <!-- <li>
            <router-link to="/personCode">
              <img src="../assets/images/j-i8.png" alt="">
              <p>专属二维码</p>
            </router-link>
          </li> -->
          <!-- <li>
            <router-link to="/account">
              <img src="../assets/images/j-i9.png" alt="">
              <p>账号管理</p>
            </router-link>
          </li> -->
          <li>
            <router-link to="/Styleywy">
              <img src="../assets/images/car.png" alt="">
              <p>待绑定样本</p>
            </router-link>
          </li>
          <li>
            <router-link to="/waitStyle">
              <img src="../assets/images/bind.png" alt="">
              <p>待回寄样本</p>
            </router-link>
          </li>
          <li>
            <router-link to="/account">
              <img src="../assets/images/j-i9.png" alt="">
              <p>账号管理</p>
            </router-link>
          </li>
          <li>
            <router-link to="/personCode">
              <img src="../assets/images/j-i8.png" alt="">
              <p>专属二维码</p>
            </router-link>
          </li>


        </ul>
      </div>




    </div>
    <!-- </cube-scroll> -->
  </div>
</template>
<script>
   import Vue from 'vue'
   import {Dialog} from 'vant'
   // 全局注册
   Vue.use(Dialog)
   export default {
      name: 'message',
      data() {
         return {
            items: [],
            options: {},
            photo: localStorage.getItem('photo') ? localStorage.getItem('photo') : '../assets/images/j-i2.png',
            list: [{}, {}, {}, {}],
            type: this.$route.params.type,
            user_id: localStorage.getItem('user_id'),
            code: '',
            openid: localStorage.getItem('openid'),
            name: ''
         }
      },
      mounted() {
         // this.$loading.show()
      },
      created() {
        /*
         this.$nextTick(() => {

         })
         */
        this.getCode()
        this.loadPage()

      },
      methods: {
         loginOut() {
            Dialog.confirm({
               title: '提示',
               message: '确定退出登录吗'
            }).then(() => {
               localStorage.removeItem('user_id')
               localStorage.removeItem('name')
               localStorage.removeItem('phone')
               localStorage.removeItem('role_id')
               localStorage.removeItem('role')
               localStorage.removeItem('type')
               localStorage.removeItem('photo')
               localStorage.removeItem('sex')
              /*
               this.$router.push({name: 'login'})

               */
              window.location.href = this.$store.state.windowhref
            }).catch(() => {
               // on cancel
            })
         },
         loadPage() {
            this.$http.api.findAvators({
               user_id: this.user_id
            }).then(result => {
               this.photo = result.photo
               this.name = result.name
            })
         },
         getCode() {
            this.code = this.$utils.getUrlKey('code')
            // alert(this.code)
            if (!this.openid && this.user_id) {
               this.$http.api.getCode({
                  user_id: this.user_id,
                  code: this.code
               }).then(result => {
                  // this.$loading.hide()
                  localStorage.setItem('openid', result)
               })
            }
         },
      }
   }
</script>
<style lang="less" scoped>
  .message {
    width: 100%;
    position: relative;
    padding-top: 21px;
    height: 100vh;
    overflow: hidden;
    background: url(../assets/images/j-p2.jpg) top center no-repeat #f285be;
    -webkit-background-size: 100% auto;
    background-size: 100% auto;

    .message-out {
      width: 100%;
      height: 100%;

      .message-goout {
        width: 100%;
        height: 20px;
        margin-bottom: 16px;

        .loginOut {
          float: right;
          width: 20px;
          height: 20px;
          margin-right: 10px;
          box-sizing: border-box;
          background: url('../assets/images/j-i3.png') center center no-repeat;
          background-size: cover;
          border-radius: 50%;
        }
      }

      .message-avator {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        overflow: hidden;
        // height: 73px;
        img {
          width: 74px;
          height: 74px;
          margin: 0 auto;
          border-radius: 50%;
        }

        p {
          width: 143px;
          height: 36px;
          font-size: 18px;
          text-align: center;
          // font-family:MicrosoftYaHei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 36px;
          margin: 0 auto;
        }
      }

      .message-list {
        height: 100%;
        padding: 0 35px;
        box-sizing: border-box;
        margin: 75px auto 0;

        ul {
          width: 100%;
          height: 100%;

          li {
            width: 100%/3;
            float: left;
            margin-bottom: 28px;

            img {
              width: 75px;
              height: 75px;
              margin: 0 auto;
            }

            p {
              width: 100%;
              height: 24px;
              font-size: 12px;
              text-align: center;
              //font-familys:MicrosoftYaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 24px;
            }
          }
        }
      }

      .message-list2 {
        height: 100%;
        padding: 0 35px;
        box-sizing: border-box;
        /*margin: 65px auto 0;*/
        margin: 20px auto 0;

        ul {
          width: 100%;
          height: 100%;
          position: relative;

          li {
            width: 33.33%;
            float: left;
            // position: absolute;
            margin-bottom: 12px;

            img {
              width: 75px;
              height: 75px;
              margin: 0 auto;
            }

            p {
              width: 100%;
              height: 24px;
              font-size: 12px;
              text-align: center;
              //font-familys:MicrosoftYaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 24px;
            }

            // &:nth-child(1){
            //   top:0;
            //   left: 17%;
            // }
            // &:nth-child(2){
            //   top:0;
            //   right: 17%;
            // }
            // &:nth-child(3){
            //   top: 20%;
            //   left: 0%;
            // }
            // &:nth-child(4){
            //   top: 18%;
            //   left: 36%;
            //   width: 85px;
            //   img{
            //     width: 85px;
            //     height: 85px;
            //   }
            // }
            // &:nth-child(5){
            //   top: 20%;
            //   right: 0%;
            // }
            // &:nth-child(6){
            //   top: 40%;
            //   left: 17%;
            // }
            // &:nth-child(7){
            //   top: 40%;
            //   right: 17%;
            // }
            // &:nth-child(8){
            //   top: 40%;
            //   left: 17%;
            // }
            // &:nth-child(9){
            //   top: 40%;
            //   right: 17%;
            // }
          }
        }
      }
    }
  }
</style>

